import { useEffect, useState } from 'react'
import { checkNewPasswordTokenService } from '../services/login';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

const useCheckNewPasswordToken = (user_name, password_auth) => {

    const navigate = useNavigate();

    const [isFetchingNewPasswordToken, setIsFetchingNewPasswordToken] = useState(true);

    const [errorNewPasswordToken, setErrorNewPasswordToken] = useState(false);

    const [messageNewPasswordToken, setMessageNewPasswordToken] = useState('');

    useEffect(() => {
        const checkNewPasswordToken = async () => {
            try {
                const response = await checkNewPasswordTokenService(user_name, password_auth);
                if (response.ok) {
                    setIsFetchingNewPasswordToken(false);
                    setErrorNewPasswordToken(false);
                } else {
                    setIsFetchingNewPasswordToken(false);
                    setErrorNewPasswordToken(true);
                    setMessageNewPasswordToken(t('LINK_EXPIRED'));
                    setTimeout(() => {
                        navigate('/login')
                    }, 2000);
                }
            } catch (e) {
                setIsFetchingNewPasswordToken(false);
                setErrorNewPasswordToken(true);
                setMessageNewPasswordToken(t('SERVER_ERROR'))
                console.log(e)
            }
        }
        checkNewPasswordToken();
        // eslint-disable-next-line
    }, [user_name, password_auth])

    return { isFetchingNewPasswordToken, errorNewPasswordToken, messageNewPasswordToken }
}

export default useCheckNewPasswordToken